import React from 'react';

import { axios } from '@bai/data';

type PassLinkProps = {
  path: string;
  children?: React.ReactNode;
  anchor?: string;
};

// non-prod environments will all use the QA wordpress site
export function getBaseUrl(): string {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'lmgr.bai.org') {
    return 'https://ld-connect.bai.org';
  }
  // Default non-production base URL
  return 'https://ldconnectqa.wpengine.com';
}

// Exposed for testing purposes so getBaseUrl can be spied on within PassLink calls
export const _passLinkHelpers = { getBaseUrl };

export const getPassJwtToken = async (): Promise<string> => {
  const response = await axios.get('api/user/passjwt');
  return response.data as string;
};

export async function PassLink({ path, anchor }: PassLinkProps) {
  const baseUrl = _passLinkHelpers.getBaseUrl();
  const tokenParam = '?mo_jwt_token=';
  const passJwtToken = await getPassJwtToken();
  const href = encodeURI(
    baseUrl + path + tokenParam + passJwtToken + (anchor ?? ''),
  );
  window.open(href, '_blank', 'noopener,noreferrer');
}

export default PassLink;
